export default __webpack_public_path__ + "static/breedon-priory-40ba69029ac9ffba6f4b869081e356bc.svg";